import { useLayoutEffect, useEffect, useCallback, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import clsx from 'clsx'
import injectSheet from 'react-jss'
import { useLocation } from 'react-router-dom'
import Meta from '@/components/Meta'
import EditorialSections from '@/components/__new/EditorialSections'
import DelayLink from '@/components/DelayLink'
import useFetchData from '@/hooks/useFetchData'
import useScrollStore from '@/store/scroll'
import actions from '@/actions'
import style from './style'

function Editorial2025({ preview, classes }) {
  const location = useLocation()
  const stub = useRef(location.pathname.replace(/^\/(\w+)\//, '').replace('/', ''))
  const { pageData: page } = useFetchData(stub.current, 'pages', false, {}, preview)
  const [load, setLoad] = useState(false)
  const lenis = useScrollStore((state) => state.lenis)

  /*------------------------------
  Redux Actions
  ------------------------------*/
  const dispatch = useDispatch()
  const updatePageReady = useCallback((index) => dispatch(actions.loading.setReady(index)), [dispatch])
  const setTranslations = useCallback((p) => dispatch(actions.locale.setTranslations(p)), [dispatch])

  useEffect(() => {
    return () => {
      setTranslations(null)
    }
  }, [])

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (lenis) lenis.stop()
  }, [lenis])

  useEffect(() => {
    if (Object.keys(page).length > 0) {
      setTranslations(page)
      updatePageReady(true)
      setLoad(true)
    }
  }, [page])

  /*------------------------------
    Render Back Link
    ------------------------------*/
  const renderBackLink = () => {
    return page?.acf?.link_back_button?.url ? (
      <DelayLink
        to={page.acf.link_back_button.url}
        className={clsx({
          [classes.backLink]: true,
          [classes.backLinkDark]: page.acf?.theme === 'dark',
        })}
      >
        <button
          className={`${classes.button} btnEye`}
          aria-label="back"
        >
          <svg>
            <use xlinkHref="#ico-download" />
          </svg>
        </button>
      </DelayLink>
    ) : null
  }

  return load ? (
    <>
      <Meta head_json={page.yoast_head} />
      <div
        className={clsx({
          [classes.root]: true,
          [classes.rootDark]: page.acf?.theme === 'dark',
        })}
      >
        {renderBackLink()}
        <EditorialSections sections={page.acf.sections} theme={page.acf?.theme} />
      </div>
    </>
  ) : null
}

export default injectSheet(style)(Editorial2025)
